import { Icon } from "@iconify/react";
import { Colors } from "../../../utils/colors";
import { useCallback, useEffect, useMemo, useState } from "react";
import PopupModalContainer, {
  PopupModalContainerWidth,
} from "../../Containers/PopupModalContainer";
import { useSelector, useDispatch } from "react-redux";
import {
  changeProfilePasswordProtect,
  getAccountState,
} from "../../../redux/slices/accountSlice";
import { useTheme } from "../../../hooks/useTheme";
import { NotificationType } from "@markit/common.types";
import { showNotificationBanner } from "../../../utils/notificationUtils";
import RectangleButton from "../../Buttons/RectangleButton";
import SwitchToggleItem from "../../SwitchToggleItem";
import CustomTextField from "../../CustomTextField";

const ProfileSettingsModal = () => {
  const { theme } = useTheme();
  const { accountData } = useSelector(getAccountState).account;
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const [profilePassword, setProfilePassword] = useState("");

  useEffect(() => {
    if (isVisible) {
      setProfilePassword(accountData.profilePasswordProtect);
    }
  }, [accountData.profilePasswordProtect, isVisible]);

  const disableSetPassword = useMemo(
    () => profilePassword === accountData.profilePasswordProtect,
    [accountData.profilePasswordProtect, profilePassword]
  );

  const changeRequirePassword = useCallback(() => {
    dispatch(changeProfilePasswordProtect(accountData.uid, profilePassword));
    showNotificationBanner(
      dispatch,
      "Password Changed!",
      NotificationType.AFFIRMATIVE
    );
    setIsVisible(false);
  }, [accountData.uid, dispatch, profilePassword]);

  const togglePasswordProtectProfile = useCallback(() => {
    const password = !profilePassword ? "Password" : "";
    setProfilePassword(password);
  }, [profilePassword]);

  return (
    <>
      <div
        className="Centering"
        style={{
          cursor: "pointer",
          width: 45,
          height: 45,
          borderRadius: 12,
          border: `0.5px solid ${Colors.GRAY2}`,
          backgroundColor: Colors.WHITE1,
        }}
        onClick={() => setIsVisible(true)}
      >
        <Icon icon="ion:cog-outline" height={21} />
      </div>
      {isVisible ? (
        <PopupModalContainer
          headerComp={<span className="sectionTitle">Profile Settings</span>}
          valueComp={
            <div className="ColumnNormal" style={{ gap: 14 }}>
              <div className="ColumnNormal" style={{ gap: 14 }}>
                <SwitchToggleItem
                  title="Password Protect Profile"
                  toggleValue={profilePassword !== ""}
                  onChange={togglePasswordProtectProfile}
                />
                {profilePassword !== "" ? (
                  <CustomTextField
                    value={profilePassword}
                    placeholder="password"
                    inputMode="text"
                    borderRadius={12}
                    noAutocomplete
                    backgroundColor={Colors.WHITE}
                    onChange={(change: any) => {
                      setProfilePassword(change.target.value);
                    }}
                    altMarginBottom={0}
                    altPadding="10px 10px"
                  />
                ) : null}
              </div>
              <div className="AlignedRow" style={{ gap: 10 }}>
                <RectangleButton
                  buttonLabel="Cancel"
                  onPress={() => setIsVisible(false)}
                  altColor={Colors.WHITE1}
                  altTextColor={Colors.BLACK}
                  altPaddingVert={16}
                  containerStyles={{
                    border: `0.5px solid ${Colors.GRAY2}`,
                  }}
                />
                <RectangleButton
                  buttonLabel="Save"
                  onPress={changeRequirePassword}
                  altColor={Colors.BLACK}
                  altTextColor={Colors.WHITE}
                  altPaddingVert={16}
                  containerStyles={{
                    pointerEvents: disableSetPassword ? "none" : "all",
                    opacity: disableSetPassword ? 0.3 : 1,
                  }}
                />
              </div>
            </div>
          }
          theme={theme}
          noExit
          closeOnOutsidePress
          closeModal={() => {
            setIsVisible(false);
            setProfilePassword("");
          }}
          modalContentWidth={PopupModalContainerWidth.SMALL}
        />
      ) : null}
    </>
  );
};

export default ProfileSettingsModal;
